import ReactDOM from "react-dom/client";
import App from "./App";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(<App />);

// if (process.env.NODE_ENV !== "production") {
//   // Helper temporal para poblar la base con datos (solo dev).
//   // Se expone como: window.seedPaquetes2025H1(...)
//   import("./utils/dev/seedPaquetes2025H1")
//     .then(({ registerSeedHelpers }) => registerSeedHelpers())
//     .catch((e) => console.error("No se pudo registrar seed helpers", e));
// }
